import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { CommonService } from "../common.service";
import { Profile, PaymentMethod } from "profile-api";
import { Router } from "@angular/router";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit {
  profile: Profile = {};

  constructor(private commonService: CommonService, private router: Router) {}

  ngOnInit() {
    this.commonService.getProfile().then((profile: Profile) => {
      this.profile = profile;
    });
  }

  buyPrepaidPacket() {
    this.commonService
      .saveProfile(this.profile)
      .then((pro: Profile) => {
        this.commonService
          .getPaymentMethodService()
          .profilePaymentMethodGet()
          .subscribe(
            (paymentMethod: PaymentMethod) => {
              this.router.navigate(["/acquistapacchetto"], {
                queryParams: { isTenderPacket: true },
              });
              //window.open('/acquistapacchetto','_self');
            },
            (error) => {
              this.router.navigate(["/areariservata"], {
                queryParams: {
                  tabToLoad: "paymentMethod",
                  fromPrepaidPacketBuy: "yes",
                },
              });
              //window.open('/areariservata?tabToLoad=paymentMethod&fromPrepaidPacketBuy=yes','_self');
            }
          );
      })
      .catch((error) => {
        this.router.navigate(["/areariservata"], {
          queryParams: { tabToLoad: "profile", fromPrepaidPacketBuy: "yes" },
        });
        //window.open('/areariservata?tabToLoad=profile&fromPrepaidPacketBuy=yes','_self');
      });
  }

  buyPrepaidParticipationPacket() {
    this.commonService
      .saveProfile(this.profile)
      .then((pro: Profile) => {
        this.commonService
          .getPaymentMethodService()
          .profilePaymentMethodGet()
          .subscribe(
            (paymentMethod: PaymentMethod) => {
              this.router.navigate(["/acquistapacchetto"], {
                queryParams: { isTenderPacket: false },
              });
              //window.open('/acquistapacchetto','_self');
            },
            (error) => {
              this.router.navigate(["/areariservata"], {
                queryParams: {
                  tabToLoad: "paymentMethod",
                  fromPrepaidPacketBuy: "yes",
                },
              });
              //window.open('/areariservata?tabToLoad=paymentMethod&fromPrepaidPacketBuy=yes','_self');
            }
          );
      })
      .catch((error) => {
        this.router.navigate(["/areariservata"], {
          queryParams: { tabToLoad: "profile", fromPrepaidPacketBuy: "yes" },
        });
        //window.open('/areariservata?tabToLoad=profile&fromPrepaidPacketBuy=yes','_self');
      });
  }
}
